import Vue from "vue";
import { INotificationOnClickResult, Notification } from "./notification";

export class SaleNotification extends Notification {
	public async onClick(vue: Vue): Promise<INotificationOnClickResult> {
		return {
			routeTo: `/sales/info/${this.Data.SaleID}`
		};
	}

	public getIcon():string {
		return "file-invoice";
	}

	public getActionKey():string {
		return "open-document";
	}
}
